/**
 * Additional Services Section for Assistant Profile
 * Handles backup equipment and editing services toggles
 */
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";

export default function AdditionalServicesSection({
  hasBackupGear,
  setHasBackupGear,
  offersEditing,
  setOffersEditing
}) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">Additional Services</h2>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-white/[0.05] border border-white/10 rounded-sm">
          <div>
            <div className="font-medium">Backup Equipment Available</div>
            <div className="text-white/50 text-sm">Extra bodies/lenses in case of emergencies</div>
          </div>
          <Switch 
            checked={hasBackupGear} 
            onCheckedChange={setHasBackupGear}
            data-testid="backup-gear-switch"
          />
        </div>
        
        <div className="flex items-center justify-between p-4 bg-white/[0.05] border border-white/10 rounded-sm">
          <div>
            <div className="font-medium">Offers Editing Services</div>
            <div className="text-white/50 text-sm">Can edit/cull images post-shoot</div>
          </div>
          <Switch 
            checked={offersEditing} 
            onCheckedChange={setOffersEditing}
            data-testid="offers-editing-switch"
          />
        </div>
      </div>
    </Card>
  );
}
